import { PLAN_DURATION } from 'ck-core/source/data/PlanDuration';

export const planDurationLang: { [K in keyof PLAN_DURATION]: string } = {
	[PLAN_DURATION.MONTH]: '1 Month',
	[PLAN_DURATION.MONTHLY]: 'Monthly',
	[PLAN_DURATION.THREE_MONTHS]: '3 Months',
	[PLAN_DURATION.THREE_MONTHLY]: 'Quarterly',
	[PLAN_DURATION.YEAR]: '12 Months',
	[PLAN_DURATION.YEARLY]: 'Annually',
	[PLAN_DURATION.LIFETIME]: 'Lifetime'
};

export const planEndDateLang = {
	long: {
		renew: (dateString: string) => `Your plan will renew on ${dateString}`,
		expire: (dateString: string) => `Your plan will expire on ${dateString}`
	},
	short: {
		renew: (dateString: string) => `Renews ${dateString}`,
		expire: (dateString: string) => `Expires ${dateString}`
	}
};
